import { PropertyUnit } from '@/api/types/property-unit';
import { PropertyUnitModel } from '@/models/property-unit';
import { transformProperty } from './property';
import { transformPropertyUnitCategory } from './property-unit-category'

export function transformPropertyUnit(propertyUnit: PropertyUnit): PropertyUnitModel {
  return {
    name: propertyUnit.name,
    property: propertyUnit.property && transformProperty(propertyUnit.property),
    doorNumber: propertyUnit.number,
    propertyUnitCategory: propertyUnit.propertyUnitCategory && transformPropertyUnitCategory(propertyUnit.propertyUnitCategory),
  };
}

export function transformPropertyUnits(propertyUnits: PropertyUnit[]): PropertyUnitModel[] {
  return propertyUnits.map(transformPropertyUnit);
}
